<template>
  <component :is="page" v-bind="pageProps" @buy="buy" v-if="product" />
</template>

<script>
import { mapActions } from 'vuex';
import FactPerson from '../components/ReportFactPerson';
import MyMonitoring from '../components/ReportMyMonitoring';
import MyPaymentDefaults from '../components/ReportMyPaymentDefaults';
import MyCreditInquiries from '../components/ReportMyCreditIquiry';
import MyFactReport from '../components/ReportMyFact';
import ReportsOnCompanies from '../components/ReportOnCompanies';

export default {
  inheritAttrs: false,
  props: {
    slug: { type: String, required: true },
  },
  components: {
    FactPerson,
    MyMonitoring,
    MyPaymentDefaults,
    ShareMyPaymentDefaults: MyPaymentDefaults,
    MyCreditInquiries,
    MyFactReport,
    ReportsOnCompanies,
    PaymentDefaults: FactPerson,
    MyCompanies: MyFactReport,
    CompaniesOnPerson: FactPerson,
  },
  data: () => ({
    product: null,
  }),
  watch: {
    '$i18n.locale': 'updateProductSlug',
    slug: {
      immediate: true,
      handler: 'loadProduct',
    },
  },
  computed: {
    productId() {
      return (this.product.alias && !this.product.id) ? this.product.alias.id : this.product.id;
    },
    page() {
      return this.product ? this.productId : '';
    },
    pageProps() {
      const { product } = this;

      if (product.alias) {
        return {
          ...product.alias.props,
          key: product.slug,
          product: {
            id: this.productId,
            icon: product.icon,
            title: product.title,
            price: product.price,
            ...product.aliasedProduct,
          },
        };
      }

      return {
        product,
        key: product.slug,
      };
    },
  },
  methods: {
    ...mapActions('product', ['getProductBySlug', 'getProductById']),
    ...mapActions('purchase', ['addToCart']),

    buy(item) {
      return this.addToCart({ ...item, id: this.productId })
        .then(() => this.$router.push({ name: `purchase-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } }));
    },
    loadProduct() {
      return this.getProductBySlug(this.slug)
        .then((product) => this.product = product);
    },
    updateProductSlug() {
      const load = this.product ? Promise.resolve(this.product) : this.loadProduct();

      return load
        .then((product) => this.getProductById(product.id))
        .then((product) => {
          this.product = product;
          this.$router.replace({ name: `report-${this.$i18n.locale}`, params: { ...product, lang: this.$i18n.locale } });
        });
    },
  },
  metaInfo() {
    const product = this.product || {};
    const meta = product.meta || {};

    return {
      title: product.title,
      meta: [
        { vmid: 'keywords', name: 'keywords', content: meta.keywords },
        { vmid: 'description', name: 'description', content: meta.description },
      ],
    };
  },
};
</script>
